import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsInEng from "../locales/en/common.json";
import translationsInPt from "../locales/pt/common.json";

// the translations
const resources = {
  pt: {
    translation: translationsInPt,
  },
  en: {
    translation: translationsInEng,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("lang"),
  debug: true,
  fallbackLng: "pt",
  interpolation: {
    escapeValue: false,
  },
  ns: "translation",
  defaultNS: "translation",
});

export default i18n;
